import { getPaymentMethodsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { UpsertAutoPayMethodBody } from '@b-stock/payments-methods-api-client'

const upsertAutoPayMethod = async (
  accessToken: string,
  upsertAutoPayMethodBody: UpsertAutoPayMethodBody
) => {
  const payMethodsClient = getPaymentMethodsClient()
  const response = await payMethodsClient.upsertAutoPayMethod(
    { upsertAutoPayMethodBody },
    buildAxiosRequestConfig({ accessToken })
  )

  return response.data
}

export default upsertAutoPayMethod
